'use strict';

const CONST = require('plugin_frontend_core/constants');

const selectors = {
    badge: '.js-badge-promotion',
    imageContainer: '.js-primary-images'
};

/**
 * @private addImageBadge
 * @param {jQueryElement} $container - The PDP container
 * @param {JSON} badge - The productBadge
 */
function addImageBadge($container, badge) {
    const template = `<div class="badge badge--promotion-discount js-badge-promotion">
            <img src="${badge.value}" alt="${badge.alt}" />
        </div>`;
    $container.find(selectors.imageContainer).parent().append(template);
}

/**
 * @private addStringBadge
 * @param {jQueryElement} $container - The PDP container
 * @param {JSON} badge - The productBadge
 */
function addStringBadge($container, badge) {
    const template = `<div class="badge badge--sale js-badge-promotion">
            <span class="badge__text">${badge.value}</span>
        </div>`;
    $container.find(selectors.imageContainer).parent().append(template);
}

/**
 * @private updateProductBadge
 * @param {JSON} product - JSON response of the Product model
 * @param {jQueryElement} $container - The PDP container
 */
function updateProductBadge(product, $container) {
    if (!product) return;

    const badge = $container.find(selectors.badge);

    // remove existing badge
    if (badge.length > 0) {
        badge.remove();
    }

    if (!product.badge) return;

    if (product.badge.type === 'image') {
        addImageBadge($container, product.badge);
    } else if (product.badge.type === 'string') {
        addStringBadge($container, product.badge);
    }
}

/**
 * @public init
 */
function init() {
    $(CONST.selectors.body).on(CONST.events.productAfterAttributeSelect, (evt, response) => {
        let $container = $(response.container);
        if ($container && $container.length > 0) {
            updateProductBadge(response.data.product, $container);
        }
    });
}

module.exports = init();
